export const arabic_alpha = [
  "ا",
  "ب",
  "ت",
  "ث",
  "ج",
  "چ",
  "ح",
  "خ",
  "د",
  "ذ",
  "ر",
  "ز",
  "ژ",
  "ص",
  "ض",
  "ط",
  "ظ",
  "ع",
  "غ",
  "ف",
  "ق",
  "ک",
  "گ",
  "ل",
  "م",
  "ن",
  "و",
  "ه",
  "ی",
];

export const arabic_alpha_bn = [
  "আলিফ",
  "বা",
  "তা",
  "ছা",
  "জীম",
  "হ্বা",
  "খ",
  "দাল",
  "জাল",
  "র",
  "ঝা",
  "সিন",
  "শিন",
  "সদ",
  "দদ",
  "ত্ব",
  "জ্ব",
  "আইন",
  "গইন",
  "ফা",
  "ক্বফ",
  "কাফ",
  "লাম",
  "মিম",
  "নুন",
  "ওয়াও",
  "হা",
  "হামযা",
  "ইয়া",
];

export const arabic_alpha_en = [
  "alif",
  "ba",
  "taa",
  "tha",
  "jim",
  "hwa",
  "kho",
  "dal",
  "jal",
  "ro",
  "jha",
  "sin",
  "shin",
  "sod",
  "dod",
  "to",
  "jo",
  "ain",
  "goin",
  "fa",
  "kof",
  "kaf",
  "lam",
  "mim",
  "nun",
  "wow",
  "ha",
  "hamza",
  "ya",
];
